// import React, { useState } from 'react';
// import Icon from '../../../components/AppIcon';
// import Button from '../../../components/ui/Button';
// import Input from '../../../components/ui/Input';
// import Select from '../../../components/ui/Select';

// const DataTable = ({ activeTab, data, onEdit, onDelete, onView }) => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [sortField, setSortField] = useState('name');
//   const [sortDirection, setSortDirection] = useState('asc');
//   const [statusFilter, setStatusFilter] = useState('all');

//   const statusOptions = [
//     { value: 'all', label: 'All Status' },
//     { value: 'active', label: 'Active' },
//     { value: 'inactive', label: 'Inactive' },
//     { value: 'pending', label: 'Pending' }
//   ];

//   const getColumns = () => {
//     switch (activeTab) {
//       case 'digital-print-operators':
//         return [
//           { key: 'name', label: 'Operator Name', sortable: true },
//           { key: 'contact', label: 'Contact', sortable: false },
//           { key: 'specialization', label: 'Specialization', sortable: true },
//           { key: 'rate', label: 'Rate (₹/Meter)', sortable: true },
//           { key: 'status', label: 'Status', sortable: true },
//           { key: 'actions', label: 'Actions', sortable: false }
//         ];
//       case 'cutting-specialists':
//         return [
//           { key: 'name', label: 'Specialist Name', sortable: true },
//           { key: 'contact', label: 'Contact', sortable: false },
//           { key: 'expertise', label: 'Expertise', sortable: true },
//           { key: 'rate', label: 'Rate (₹/Piece)', sortable: true },
//           { key: 'status', label: 'Status', sortable: true },
//           { key: 'actions', label: 'Actions', sortable: false }
//         ];
//       case 'raw-material-suppliers':
//         return [
//           { key: 'name', label: 'Supplier Name', sortable: true },
//           { key: 'contact', label: 'Contact', sortable: false },
//           { key: 'materials', label: 'Materials', sortable: false },
//           { key: 'kgRate', label: 'KG Rate (₹)', sortable: true },
//           { key: 'meterRate', label: 'Meter Rate (₹)', sortable: true },
//           { key: 'status', label: 'Status', sortable: true },
//           { key: 'actions', label: 'Actions', sortable: false }
//         ];
//       case 'clients':
//         return [
//           { key: 'name', label: 'Client Name', sortable: true },
//           { key: 'contact', label: 'Contact', sortable: false },
//           { key: 'platform', label: 'Platform', sortable: true },
//           { key: 'onlineRate', label: 'Online Rate (₹)', sortable: true },
//           { key: 'offlineRate', label: 'Offline Rate (₹)', sortable: true },
//           { key: 'status', label: 'Status', sortable: true },
//           { key: 'actions', label: 'Actions', sortable: false }
//         ];
//       case 'purchase-invoices':
//         return [
//           { key: 'invoiceNumber', label: 'Invoice Number', sortable: true },
//           { key: 'supplier', label: 'Supplier', sortable: true },
//           { key: 'invoiceDate', label: 'Invoice Date', sortable: true },
//           { key: 'totalAmount', label: 'Total Amount (₹)', sortable: true },
//           { key: 'materials', label: 'Materials', sortable: false },
//           { key: 'status', label: 'Status', sortable: true },
//           { key: 'actions', label: 'Actions', sortable: false }
//         ];
//       default:
//         return [
//           { key: 'name', label: 'Party Name', sortable: true },
//           { key: 'contact', label: 'Contact', sortable: false },
//           { key: 'type', label: 'Type', sortable: true },
//           { key: 'status', label: 'Status', sortable: true },
//           { key: 'actions', label: 'Actions', sortable: false }
//         ];
//     }
//   };

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
//     } else {
//       setSortField(field);
//       setSortDirection('asc');
//     }
//   };

//   const filteredData = data.filter(item => {
//     const matchesSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                          item.contact.phone.includes(searchTerm) ||
//                          item.contact.email.toLowerCase().includes(searchTerm.toLowerCase());
//     const matchesStatus = statusFilter === 'all' || item.status === statusFilter;
//     return matchesSearch && matchesStatus;
//   });

//   const sortedData = [...filteredData].sort((a, b) => {
//     if (!sortField) return 0;
    
//     let aValue = a[sortField];
//     let bValue = b[sortField];
    
//     if (typeof aValue === 'string') {
//       aValue = aValue.toLowerCase();
//       bValue = bValue.toLowerCase();
//     }
    
//     if (sortDirection === 'asc') {
//       return aValue > bValue ? 1 : -1;
//     } else {
//       return aValue < bValue ? 1 : -1;
//     }
//   });

//   const renderCellContent = (item, column) => {
//     switch (column.key) {
//       case 'name':
//         return (
//           <div className="flex items-center space-x-3">
//             <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
//               <span className="text-sm font-medium text-primary">
//                 {item.name?.charAt(0).toUpperCase() || item.invoiceNumber?.charAt(0).toUpperCase()}
//               </span>
//             </div>
//             <div>
//               <p className="font-medium text-foreground">{item.name}</p>
//               <p className="text-xs text-muted-foreground">{item.code}</p>
//             </div>
//           </div>
//         );
//       case 'invoiceNumber':
//         return (
//           <div className="flex items-center space-x-3">
//             <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
//               <Icon name="Receipt" size={16} className="text-primary" />
//             </div>
//             <div>
//               <p className="font-medium text-foreground">{item.invoiceNumber}</p>
//               <p className="text-xs text-muted-foreground">#{item.id}</p>
//             </div>
//           </div>
//         );
//       case 'supplier':
//         return (
//           <div>
//             <p className="font-medium text-foreground">{item.supplier?.name}</p>
//             <p className="text-xs text-muted-foreground">{item.supplier?.code}</p>
//           </div>
//         );
//       case 'invoiceDate':
//         return (
//           <div>
//             <p className="text-sm text-foreground">
//               {new Date(item.invoiceDate).toLocaleDateString('en-IN')}
//             </p>
//             <p className="text-xs text-muted-foreground">
//               {new Date(item.invoiceDate).toLocaleDateString('en-IN', { 
//                 weekday: 'short' 
//               })}
//             </p>
//           </div>
//         );
//       case 'totalAmount':
//         return (
//           <div>
//             <span className="font-medium text-foreground">
//               ₹{item.totalAmount?.toLocaleString('en-IN') || '0'}
//             </span>
//             {item.taxAmount && (
//               <p className="text-xs text-muted-foreground">
//                 +₹{item.taxAmount.toLocaleString('en-IN')} tax
//               </p>
//             )}
//           </div>
//         );
//       case 'contact':
//         return (
//           <div>
//             <p className="text-sm text-foreground">{item.contact?.phone}</p>
//             <p className="text-xs text-muted-foreground">{item.contact?.email}</p>
//           </div>
//         );
//       case 'status':
//         return (
//           <span className={`px-2 py-1 rounded-full text-xs font-medium ${
//             item.status === 'active' ? 'bg-success/10 text-success' :
//             item.status === 'paid' ? 'bg-success/10 text-success' :
//             item.status === 'pending' ? 'bg-warning/10 text-warning' :
//             item.status === 'overdue' ? 'bg-error/10 text-error' :
//             item.status === 'inactive'? 'bg-error/10 text-error' : 'bg-warning/10 text-warning'
//           }`}>
//             {item.status?.charAt(0).toUpperCase() + item.status?.slice(1)}
//           </span>
//         );
//       case 'rate': case'kgRate': case'meterRate': case'onlineRate': case'offlineRate':
//         return (
//           <span className="font-medium text-foreground">
//             ₹{item[column.key]?.toLocaleString('en-IN') || '0'}
//           </span>
//         );
//       case 'platform':
//         return (
//           <div className="flex flex-wrap gap-1">
//             {item.platforms?.map((platform, index) => (
//               <span key={index} className="px-2 py-1 bg-accent/10 text-accent rounded text-xs">
//                 {platform}
//               </span>
//             ))}
//           </div>
//         );
//       case 'materials':
//         return (
//           <div className="flex flex-wrap gap-1">
//             {(item.materials || item.items)?.slice(0, 2).map((material, index) => (
//               <span key={index} className="px-2 py-1 bg-accent/10 text-accent rounded text-xs">
//                 {typeof material === 'string' ? material : material.material}
//               </span>
//             ))}
//             {(item.materials || item.items)?.length > 2 && (
//               <span className="text-xs text-muted-foreground">
//                 +{(item.materials || item.items).length - 2} more
//               </span>
//             )}
//           </div>
//         );
//       case 'actions':
//         return (
//           <div className="flex items-center space-x-1">
//             <Button
//               variant="ghost"
//               size="icon"
//               onClick={() => onView(item)}
//               iconName="Eye"
//               iconSize={16}
//               className="h-8 w-8"
//             />
//             <Button
//               variant="ghost"
//               size="icon"
//               onClick={() => onEdit(item)}
//               iconName="Edit"
//               iconSize={16}
//               className="h-8 w-8"
//             />
//             <Button
//               variant="ghost"
//               size="icon"
//               onClick={() => onDelete(item)}
//               iconName="Trash2"
//               iconSize={16}
//               className="h-8 w-8 text-error hover:text-error"
//             />
//           </div>
//         );
//       default:
//         return <span className="text-foreground">{item[column.key]}</span>;
//     }
//   };

//   const columns = getColumns();

//   return (
//     <div className="space-y-4">
//       {/* Search and Filter Controls */}
//       <div className="flex flex-col sm:flex-row gap-4">
//         <div className="flex-1">
//           <Input
//             type="search"
//             placeholder="Search by name, phone, or email..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="w-full"
//           />
//         </div>
//         <div className="w-full sm:w-48">
//           <Select
//             options={statusOptions}
//             value={statusFilter}
//             onChange={setStatusFilter}
//             placeholder="Filter by status"
//           />
//         </div>
//       </div>

//       {/* Desktop Table */}
//       <div className="hidden lg:block bg-card border border-border rounded-lg overflow-hidden">
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead className="bg-muted/50">
//               <tr>
//                 {columns.map((column) => (
//                   <th key={column.key} className="px-4 py-3 text-left">
//                     {column.sortable ? (
//                       <Button
//                         variant="ghost"
//                         size="sm"
//                         onClick={() => handleSort(column.key)}
//                         className="h-auto p-0 font-medium text-foreground hover:text-primary"
//                       >
//                         {column.label}
//                         {sortField === column.key && (
//                           <Icon 
//                             name={sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown'} 
//                             size={16} 
//                             className="ml-1" 
//                           />
//                         )}
//                       </Button>
//                     ) : (
//                       <span className="font-medium text-foreground">{column.label}</span>
//                     )}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {sortedData.map((item, index) => (
//                 <tr key={item.id} className="border-t border-border hover:bg-muted/25 transition-smooth">
//                   {columns.map((column) => (
//                     <td key={column.key} className="px-4 py-3">
//                       {renderCellContent(item, column)}
//                     </td>
//                   ))}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Mobile/Tablet Cards */}
//       <div className="lg:hidden space-y-4">
//         {sortedData.map((item) => (
//           <div key={item.id} className="bg-card border border-border rounded-lg p-4">
//             <div className="flex items-start justify-between mb-3">
//               <div className="flex items-center space-x-3">
//                 <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
//                   {activeTab === 'purchase-invoices' ? (
//                     <Icon name="Receipt" size={16} className="text-primary" />
//                   ) : (
//                     <span className="text-sm font-medium text-primary">
//                       {(item.name || item.invoiceNumber)?.charAt(0).toUpperCase()}
//                     </span>
//                   )}
//                 </div>
//                 <div>
//                   <h3 className="font-medium text-foreground">
//                     {item.name || item.invoiceNumber}
//                   </h3>
//                   <p className="text-xs text-muted-foreground">
//                     {item.code || `#${item.id}`}
//                   </p>
//                 </div>
//               </div>
//               <span className={`px-2 py-1 rounded-full text-xs font-medium ${
//                 item.status === 'active' ? 'bg-success/10 text-success' :
//                 item.status === 'paid' ? 'bg-success/10 text-success' :
//                 item.status === 'pending' ? 'bg-warning/10 text-warning' :
//                 item.status === 'overdue' ? 'bg-error/10 text-error' :
//                 item.status === 'inactive'? 'bg-error/10 text-error' : 'bg-warning/10 text-warning'
//               }`}>
//                 {item.status?.charAt(0).toUpperCase() + item.status?.slice(1)}
//               </span>
//             </div>
            
//             <div className="space-y-2 mb-4">
//               {activeTab === 'purchase-invoices' ? (
//                 <>
//                   <div className="flex items-center space-x-2">
//                     <Icon name="Building" size={14} className="text-muted-foreground" />
//                     <span className="text-sm text-foreground">{item.supplier?.name}</span>
//                   </div>
//                   <div className="flex items-center space-x-2">
//                     <Icon name="Calendar" size={14} className="text-muted-foreground" />
//                     <span className="text-sm text-foreground">
//                       {new Date(item.invoiceDate).toLocaleDateString('en-IN')}
//                     </span>
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div className="flex items-center space-x-2">
//                     <Icon name="Phone" size={14} className="text-muted-foreground" />
//                     <span className="text-sm text-foreground">{item.contact?.phone}</span>
//                   </div>
//                   <div className="flex items-center space-x-2">
//                     <Icon name="Mail" size={14} className="text-muted-foreground" />
//                     <span className="text-sm text-foreground">{item.contact?.email}</span>
//                   </div>
//                 </>
//               )}
//               {(item.platforms || item.materials || item.items) && (
//                 <div className="flex flex-wrap gap-1 mt-2">
//                   {(item.platforms || item.materials || item.items)?.slice(0, 3).map((tag, index) => (
//                     <span key={index} className="px-2 py-1 bg-accent/10 text-accent rounded text-xs">
//                       {typeof tag === 'string' ? tag : tag.material || tag.platform}
//                     </span>
//                   ))}
//                   {(item.platforms || item.materials || item.items)?.length > 3 && (
//                     <span className="text-xs text-muted-foreground">
//                       +{(item.platforms || item.materials || item.items).length - 3} more
//                     </span>
//                   )}
//                 </div>
//               )}
//             </div>
            
//             <div className="flex items-center justify-between pt-3 border-t border-border">
//               <div className="text-sm">
//                 {activeTab === 'purchase-invoices' ? (
//                   <span className="text-foreground font-medium">₹{item.totalAmount?.toLocaleString('en-IN')}</span>
//                 ) : activeTab === 'raw-material-suppliers' ? (
//                   <span className="text-foreground">KG: ₹{item.kgRate?.toLocaleString('en-IN')} | Meter: ₹{item.meterRate?.toLocaleString('en-IN')}</span>
//                 ) : activeTab === 'clients' ? (
//                   <span className="text-foreground">Online: ₹{item.onlineRate?.toLocaleString('en-IN')} | Offline: ₹{item.offlineRate?.toLocaleString('en-IN')}</span>
//                 ) : (
//                   <span className="text-foreground">Rate: ₹{item.rate?.toLocaleString('en-IN')}</span>
//                 )}
//               </div>
//               <div className="flex items-center space-x-1">
//                 <Button
//                   variant="ghost"
//                   size="icon"
//                   onClick={() => onView(item)}
//                   iconName="Eye"
//                   iconSize={16}
//                   className="h-8 w-8"
//                 />
//                 <Button
//                   variant="ghost"
//                   size="icon"
//                   onClick={() => onEdit(item)}
//                   iconName="Edit"
//                   iconSize={16}
//                   className="h-8 w-8"
//                 />
//                 <Button
//                   variant="ghost"
//                   size="icon"
//                   onClick={() => onDelete(item)}
//                   iconName="Trash2"
//                   iconSize={16}
//                   className="h-8 w-8 text-error hover:text-error"
//                 />
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Empty State */}
//       {sortedData.length === 0 && (
//         <div className="text-center py-12 bg-card border border-border rounded-lg">
//           <Icon name="Database" size={48} className="mx-auto text-muted-foreground mb-4" />
//           <h3 className="text-lg font-medium text-foreground mb-2">No Data Found</h3>
//           <p className="text-muted-foreground mb-4">
//             {searchTerm ? 'No results match your search criteria.' : 'No records available in this category.'}
//           </p>
//           {searchTerm && (
//             <Button
//               variant="outline"
//               size="sm"
//               onClick={() => setSearchTerm('')}
//               iconName="X"
//               iconPosition="left"
//               iconSize={16}
//             >
//               Clear Search
//             </Button>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default DataTable;











import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const DataTable = ({ activeTab, data, onEdit, onDelete, onView }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [statusFilter, setStatusFilter] = useState('all');

  const getStatusOptions = () => {
    if (activeTab === 'purchase-invoices') {
      return [
        { value: 'all', label: 'All Status' },
        { value: 'pending', label: 'Pending' },
        { value: 'paid', label: 'Paid' },
        { value: 'overdue', label: 'Overdue' }
      ];
    }
    return [
      { value: 'all', label: 'All Status' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'pending', label: 'Pending' }
    ];
  };

  const getColumns = () => {
    switch (activeTab) {
      case 'digital-print-operators':
        return [
          { key: 'name', label: 'Operator Name', sortable: true },
          { key: 'contact', label: 'Contact', sortable: false },
          { key: 'specialization', label: 'Specialization', sortable: true },
          { key: 'rate', label: 'Rate (₹/Meter)', sortable: true },
          { key: 'status', label: 'Status', sortable: true },
          { key: 'actions', label: 'Actions', sortable: false }
        ];
      case 'cutting-specialists':
        return [
          { key: 'name', label: 'Specialist Name', sortable: true },
          { key: 'contact', label: 'Contact', sortable: false },
          { key: 'expertise', label: 'Expertise', sortable: true },
          { key: 'rate', label: 'Rate (₹/Piece)', sortable: true },
          { key: 'status', label: 'Status', sortable: true },
          { key: 'actions', label: 'Actions', sortable: false }
        ];
      case 'raw-material-suppliers':
        return [
          { key: 'name', label: 'Supplier Name', sortable: true },
          { key: 'contact', label: 'Contact', sortable: false },
          { key: 'materials', label: 'Materials', sortable: false },
          { key: 'kgRate', label: 'KG Rate (₹)', sortable: true },
          { key: 'meterRate', label: 'Meter Rate (₹)', sortable: true },
          { key: 'status', label: 'Status', sortable: true },
          { key: 'actions', label: 'Actions', sortable: false }
        ];
      case 'clients':
        return [
          { key: 'name', label: 'Client Name', sortable: true },
          { key: 'contact', label: 'Contact', sortable: false },
          { key: 'platform', label: 'Platform', sortable: true },
          { key: 'onlineRate', label: 'Online Rate (₹)', sortable: true },
          { key: 'offlineRate', label: 'Offline Rate (₹)', sortable: true },
          { key: 'status', label: 'Status', sortable: true },
          { key: 'actions', label: 'Actions', sortable: false }
        ];
      case 'purchase-invoices':
        return [
          { key: 'invoiceNumber', label: 'Invoice Number', sortable: true },
          { key: 'supplier', label: 'Supplier', sortable: true },
          { key: 'invoiceDate', label: 'Invoice Date', sortable: true },
          { key: 'totalAmount', label: 'Total Amount (₹)', sortable: true },
          { key: 'materials', label: 'Materials', sortable: false },
          { key: 'status', label: 'Status', sortable: true },
          { key: 'actions', label: 'Actions', sortable: false }
        ];
      default:
        return [
          { key: 'name', label: 'Party Name', sortable: true },
          { key: 'contact', label: 'Contact', sortable: false },
          { key: 'type', label: 'Type', sortable: true },
          { key: 'status', label: 'Status', sortable: true },
          { key: 'actions', label: 'Actions', sortable: false }
        ];
    }
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const getSearchableText = (item) => {
    if (activeTab === 'purchase-invoices') {
      return [
        item.invoiceNumber || '',
        item.supplier?.name || '',
        item.supplier?.code || '',
        item.notes || '',
        ...(item.items || []).map(i => i.material || '')
      ].join(' ').toLowerCase();
    } else {
      return [
        item.name || '',
        item.code || '',
        item.contact?.phone || '',
        item.contact?.email || '',
        item.type || '',
        item.specialization || '',
        item.expertise || '',
        ...(item.materials || []),
        ...(item.platforms || [])
      ].join(' ').toLowerCase();
    }
  };

  const filteredData = data.filter(item => {
    const searchableText = getSearchableText(item);
    const matchesSearch = searchableText.includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || item.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const getSortValue = (item, field) => {
    switch (field) {
      case 'supplier':
        return item.supplier?.name || '';
      case 'invoiceDate':
        return new Date(item.invoiceDate || 0);
      case 'totalAmount':
        return item.totalAmount || 0;
      default:
        return item[field] || '';
    }
  };

  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortField) return 0;
    
    let aValue = getSortValue(a, sortField);
    let bValue = getSortValue(b, sortField);
    
    if (typeof aValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }
    
    if (sortDirection === 'asc') {
      return aValue > bValue ? 1 : -1;
    } else {
      return aValue < bValue ? 1 : -1;
    }
  });

  const renderCellContent = (item, column) => {
    switch (column.key) {
      case 'name':
        return (
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
              <span className="text-sm font-medium text-primary">
                {item.name?.charAt(0).toUpperCase()}
              </span>
            </div>
            <div>
              <p className="font-medium text-foreground">{item.name}</p>
              <p className="text-xs text-muted-foreground">{item.code}</p>
            </div>
          </div>
        );
      case 'invoiceNumber':
        return (
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="Receipt" size={16} className="text-primary" />
            </div>
            <div>
              <p className="font-medium text-foreground">{item.invoiceNumber}</p>
              <p className="text-xs text-muted-foreground">#{item.id}</p>
            </div>
          </div>
        );
      case 'supplier':
        return (
          <div>
            <p className="font-medium text-foreground">{item.supplier?.name || 'N/A'}</p>
            <p className="text-xs text-muted-foreground">{item.supplier?.code || ''}</p>
          </div>
        );
      case 'invoiceDate':
        return (
          <div>
            <p className="text-sm text-foreground">
              {item.invoiceDate ? new Date(item.invoiceDate).toLocaleDateString('en-IN') : 'N/A'}
            </p>
            {item.invoiceDate && (
              <p className="text-xs text-muted-foreground">
                {new Date(item.invoiceDate).toLocaleDateString('en-IN', { 
                  weekday: 'short' 
                })}
              </p>
            )}
          </div>
        );
      case 'totalAmount':
        return (
          <div>
            <span className="font-medium text-foreground">
              ₹{item.totalAmount?.toLocaleString('en-IN') || '0'}
            </span>
            {item.taxAmount && (
              <p className="text-xs text-muted-foreground">
                +₹{item.taxAmount.toLocaleString('en-IN')} tax
              </p>
            )}
          </div>
        );
      case 'contact':
        return (
          <div>
            <p className="text-sm text-foreground">{item.contact?.phone || 'N/A'}</p>
            <p className="text-xs text-muted-foreground">{item.contact?.email || ''}</p>
          </div>
        );
      case 'status':
        return (
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
            item.status === 'active' ? 'bg-success/10 text-success' :
            item.status === 'paid' ? 'bg-success/10 text-success' :
            item.status === 'pending' ? 'bg-warning/10 text-warning' :
            item.status === 'overdue' ? 'bg-error/10 text-error' :
            item.status === 'inactive' ? 'bg-error/10 text-error' : 'bg-warning/10 text-warning'
          }`}>
            {item.status?.charAt(0).toUpperCase() + item.status?.slice(1) || 'Unknown'}
          </span>
        );
      case 'rate':
      case 'kgRate':
      case 'meterRate':
      case 'onlineRate':
      case 'offlineRate':
        return (
          <span className="font-medium text-foreground">
            ₹{item[column.key]?.toLocaleString('en-IN') || '0'}
          </span>
        );
      case 'platform':
        return (
          <div className="flex flex-wrap gap-1">
            {item.platforms?.map((platform, index) => (
              <span key={index} className="px-2 py-1 bg-accent/10 text-accent rounded text-xs">
                {platform}
              </span>
            ))}
          </div>
        );
      case 'materials':
        const materials = item.materials || item.items || [];
        return (
          <div className="flex flex-wrap gap-1">
            {materials.slice(0, 2).map((material, index) => (
              <span key={index} className="px-2 py-1 bg-accent/10 text-accent rounded text-xs">
                {typeof material === 'string' ? material : material.material}
              </span>
            ))}
            {materials.length > 2 && (
              <span className="text-xs text-muted-foreground">
                +{materials.length - 2} more
              </span>
            )}
          </div>
        );
      case 'actions':
        return (
          <div className="flex items-center space-x-1">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onView(item)}
              iconName="Eye"
              iconSize={16}
              className="h-8 w-8"
            />
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onEdit(item)}
              iconName="Edit"
              iconSize={16}
              className="h-8 w-8"
            />
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onDelete(item)}
              iconName="Trash2"
              iconSize={16}
              className="h-8 w-8 text-error hover:text-error"
            />
          </div>
        );
      default:
        return <span className="text-foreground">{item[column.key] || 'N/A'}</span>;
    }
  };

  const columns = getColumns();
  const statusOptions = getStatusOptions();

  return (
    <div className="space-y-4">
      {/* Search and Filter Controls */}
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <Input
            type="search"
            placeholder={
              activeTab === 'purchase-invoices' 
                ? "Search by invoice number, supplier, or materials..."
                : "Search by name, phone, or email..."
            }
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-white text-black"
          />
        </div>
        <div className="w-full sm:w-48">
          <Select
            options={statusOptions}
            value={statusFilter}
            onChange={setStatusFilter}
            placeholder="Filter by status"
          />
        </div>
      </div>

      {/* Desktop Table */}
      <div className="bg-card border border-border rounded-lg overflow-hidden">
  <div className="overflow-x-auto sm:overflow-x-visible">
    <table className="w-full table-auto sm:table-fixed">
            <thead className="bg-muted/50">
              <tr>
                {columns.map((column) => (
                  <th key={column.key} className="px-4 py-3 text-left">
                    {column.sortable ? (
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => handleSort(column.key)}
                        className="h-auto p-0 font-medium text-foreground hover:text-primary"
                      >
                        {column.label}
                        {sortField === column.key && (
                          <Icon 
                            name={sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown'} 
                            size={16} 
                            className="ml-1" 
                          />
                        )}
                      </Button>
                    ) : (
                      <span className="font-medium text-foreground">{column.label}</span>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sortedData.map((item, index) => (
                <tr key={item.id} className="border-t border-border hover:bg-muted/25 transition-smooth">
                  {columns.map((column) => (
                    <td key={column.key} className="px-4 py-3">
                      {renderCellContent(item, column)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile/Tablet Cards */}
      <div className="lg:hidden space-y-4">
        {sortedData.map((item) => (
          <div key={item.id} className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                  {activeTab === 'purchase-invoices' ? (
                    <Icon name="Receipt" size={16} className="text-primary" />
                  ) : (
                    <span className="text-sm font-medium text-primary">
                      {(item.name || item.invoiceNumber)?.charAt(0).toUpperCase()}
                    </span>
                  )}
                </div>
                <div>
                  <h3 className="font-medium text-foreground">
                    {item.name || item.invoiceNumber}
                  </h3>
                  <p className="text-xs text-muted-foreground">
                    {item.code || `#${item.id}`}
                  </p>
                </div>
              </div>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                item.status === 'active' ? 'bg-success/10 text-success' :
                item.status === 'paid' ? 'bg-success/10 text-success' :
                item.status === 'pending' ? 'bg-warning/10 text-warning' :
                item.status === 'overdue' ? 'bg-error/10 text-error' :
                item.status === 'inactive' ? 'bg-error/10 text-error' : 'bg-warning/10 text-warning'
              }`}>
                {item.status?.charAt(0).toUpperCase() + item.status?.slice(1) || 'Unknown'}
              </span>
            </div>
            
            <div className="space-y-2 mb-4">
              {activeTab === 'purchase-invoices' ? (
                <>
                  <div className="flex items-center space-x-2">
                    <Icon name="Building" size={14} className="text-muted-foreground" />
                    <span className="text-sm text-foreground">{item.supplier?.name || 'N/A'}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Icon name="Calendar" size={14} className="text-muted-foreground" />
                    <span className="text-sm text-foreground">
                      {item.invoiceDate ? new Date(item.invoiceDate).toLocaleDateString('en-IN') : 'N/A'}
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex items-center space-x-2">
                    <Icon name="Phone" size={14} className="text-muted-foreground" />
                    <span className="text-sm text-foreground">{item.contact?.phone || 'N/A'}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Icon name="Mail" size={14} className="text-muted-foreground" />
                    <span className="text-sm text-foreground">{item.contact?.email || 'N/A'}</span>
                  </div>
                </>
              )}
              {(item.platforms || item.materials || item.items) && (
                <div className="flex flex-wrap gap-1 mt-2">
                  {(item.platforms || item.materials || item.items)?.slice(0, 3).map((tag, index) => (
                    <span key={index} className="px-2 py-1 bg-accent/10 text-accent rounded text-xs">
                      {typeof tag === 'string' ? tag : tag.material || tag.platform}
                    </span>
                  ))}
                  {(item.platforms || item.materials || item.items)?.length > 3 && (
                    <span className="text-xs text-muted-foreground">
                      +{(item.platforms || item.materials || item.items).length - 3} more
                    </span>
                  )}
                </div>
              )}
            </div>
            
            <div className="flex items-center justify-between pt-3 border-t border-border">
              <div className="text-sm">
                {activeTab === 'purchase-invoices' ? (
                  <span className="text-foreground font-medium">₹{item.totalAmount?.toLocaleString('en-IN') || '0'}</span>
                ) : activeTab === 'raw-material-suppliers' ? (
                  <span className="text-foreground">KG: ₹{item.kgRate?.toLocaleString('en-IN') || '0'} | Meter: ₹{item.meterRate?.toLocaleString('en-IN') || '0'}</span>
                ) : activeTab === 'clients' ? (
                  <span className="text-foreground">Online: ₹{item.onlineRate?.toLocaleString('en-IN') || '0'} | Offline: ₹{item.offlineRate?.toLocaleString('en-IN') || '0'}</span>
                ) : (
                  <span className="text-foreground">Rate: ₹{item.rate?.toLocaleString('en-IN') || '0'}</span>
                )}
              </div>
              <div className="flex items-center space-x-1">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onView(item)}
                  iconName="Eye"
                  iconSize={16}
                  className="h-8 w-8"
                />
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onEdit(item)}
                  iconName="Edit"
                  iconSize={16}
                  className="h-8 w-8"
                />
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onDelete(item)}
                  iconName="Trash2"
                  iconSize={16}
                  className="h-8 w-8 text-error hover:text-error"
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {sortedData.length === 0 && (
        <div className="text-center py-12 bg-card border border-border rounded-lg">
          <Icon name="Database" size={48} className="mx-auto text-muted-foreground mb-4" />
          <h3 className="text-lg font-medium text-foreground mb-2">No Data Found</h3>
          <p className="text-muted-foreground mb-4">
            {searchTerm ? 'No results match your search criteria.' : 'No records available in this category.'}
          </p>
          {searchTerm && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => setSearchTerm('')}
              iconName="X"
              iconPosition="left"
              iconSize={16}
            >
              Clear Search
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default DataTable;